import { DownloadSimpleIcon as PhosphorDownloadSimpleIcon } from "@phosphor-icons/react/dist/ssr/DownloadSimple";

import { createAppIcon } from "@/components/createAppIcon";

export const DownloadIcon = /* @__PURE__ */ createAppIcon(PhosphorDownloadSimpleIcon);
